// AI lesson generator store. Not persisted (MVP has no client-side draft save —
// matching the wizard's intentional data-loss-on-reload), so it is omitted from
// the persistedstate `paths` allowlist in store/index.js.
const state = {
  limits: null,
  // Speaking-wizard catalogue cache, keyed `${locale}|${targetLanguage}`: the topic and
  // goal NAMES are localized by Accept-Language and the character roster is per target
  // language, so both belong in the key. Deliberately not persisted either — a stale
  // roster restored from localStorage is worse than one extra request.
  catalogues: {},
  catalogueStatus: {},
  activeCatalogueKey: ''
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/aiLesson/state.js